import { uuid } from 'vue-uuid';
import { mapGetters } from 'vuex';
import _ from 'lodash';

import { ioListOptions, ioSaveOption } from '@/febos/servicios/api/herramientas.api';

export const OPTION_STATES = {
  ACTIVE: 0,
  INACTIVE: 1
};
export const OPTION_LEVELS = {
  GLOBAL: 0,
  COMPANY: 10
};

export default {
  data() {
    return {
      page: 1,
      paginate: 1000,
      OPTION_LEVELS,
      OPTION_STATES,
      states: [OPTION_STATES.ACTIVE],
      search: '',
      loading: false,
      showHide: false,
      options: [],
      option: {},
      pagination: {
        pages: 1,
      }
    };
  },

  async mounted() {
    await this.loadOptions();
  },
  computed: {
    ...mapGetters('Usuario', ['hasPermission']),
    checkIfIsSuperAdmin() {
      return this.hasPermission('FEB99');
    },
    filteredOptions() {
      this.options.sort((a, b) => a.orden - b.orden);
      if (!this.search) {
        return this.options.sort();
      }
      const word = this.search;
      return this.options.filter(
        (option) => option.descripcion.toLowerCase().includes(word.toLowerCase())
      );
    }
  },
  methods: {
    showHidesOptionsTogle: _.debounce(function showHidesOptionsTogle() {
      this.showHide = !this.showHide;
      if (this.showHide) {
        this.states = [OPTION_STATES.ACTIVE, OPTION_STATES.INACTIVE];
      } else {
        this.states = [OPTION_STATES.ACTIVE];
      }
      this.loadOptions();
    }, 300),
    setOptions(options) {
      this.options = options;
    },
    /**
     * Method loads the options of a group
     * @param groupId option group identifier
     * @param states estados separados por , que se listaran
     * @returns {Promise<void>}
     */
    debounceLoadOptions: _.debounce(async function debounceLoadOptions() {
      const queryRequest = {
        grupoOpcion: this.groupId,
        filtros: `deshabilitado:${this.states.join(',')}`,
        orden: this.extras.orden || '',
        itemsPorPagina: this.paginate,
        pagina: this.page,
        query: this.search.toLowerCase() || ''
      };
      this.loading = true;
      const response = await ioListOptions(queryRequest);
      const { opciones, totalPaginas } = response.data;
      this.setOptions(opciones, this.page);
      this.pagination.pages = totalPaginas;
      this.loading = false;
    }, 500),
    async loadOptions(page) {
      try {
        this.loading = true;
        const currentPage = page || this.page;
        const response = await ioListOptions({
          grupoOpcion: this.groupId,
          filtros: `deshabilitado:${this.states.join(',')}`,
          orden: this.extras.orden || '',
          itemsPorPagina: this.paginate,
          pagina: currentPage,
        });
        const { opciones, totalPaginas } = response.data;
        this.setOptions(opciones, currentPage);
        this.pagination.pages = totalPaginas;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    /**
     * Called after an option is edited or created
     * @param option
     */
    async savedOption(option) {
      if (!option.padre) {
        const optionIndex = this.options.findIndex(
          (optionItem) => optionItem.opcionId === option.opcionId
        );
        if (optionIndex > -1) {
          const options = [
            ...this.options.slice(0, optionIndex),
            ...[option],
            ...this.options.slice(optionIndex + 1)
          ];
          this.setOptions(options);
        } else {
          this.setOptions([...this.options, option]);
        }
      } else {
        await this.loadOptions();
      }
      this.$refs['option-modal'].hide();
    },
    addOptionNew(parent) {
      const optionId = uuid.v4();
      let orden = this.options.length;
      // find max order un this.options
      if (this.options.length > 0) {
        const maxOrder = Math.max(...this.options.map((option) => option.orden));
        orden = maxOrder + 1;
      }
      this.option = {
        descripcion: '',
        deshabilitado: OPTION_STATES.ACTIVE,
        grupoId: this.groupId,
        orden,
        nivel: this.extras.nivel >= 0 ? this.extras.nivel : OPTION_LEVELS.COMPANY,
        opcionId: optionId,
        parametroId: optionId,
        valor: '',
        extra: this.extras.extras || {}
      };
      if (parent) {
        this.option.padre = parent;
      }
      this.$refs['option-modal'].setOption(this.option);
      this.$refs['option-modal'].show();
    },
    copyToOptionNew(option) {
      const optionId = uuid.v4();
      this.option = {
        ...option,
        extra: JSON.parse(option.extra || '{}'),
        opcionId: optionId,
        parametroId: optionId,
      };
      this.$refs['option-modal'].setOption(this.option);
      this.$refs['option-modal'].show();
    },
    editOption(option) {
      const optionToEdit = { ...option, extra: JSON.parse(option.extra || '{}') };
      this.$refs['option-modal'].setOption(optionToEdit);
      this.$refs['option-modal'].show();
    },
    async deleteOptionCompany(option) {
      await this.deleteOption({ ...option, nivel: OPTION_LEVELS.COMPANY });
      this.loadOptions();
    },
    async activeOption(option, level = OPTION_LEVELS.COMPANY) {
      await this.deleteOption({ ...option, nivel: level }, OPTION_STATES.ACTIVE);
      this.loadOptions();
    },
    async deleteOption(option, state = OPTION_STATES.INACTIVE) {
      this.loading = true;
      try {
        const optionDelete = {
          ...option,
          deshabilitado: state
        };
        const param = {
          global: option.nivel === OPTION_LEVELS.GLOBAL ? 'si' : 'no',
          id: optionDelete.opcionId
        };
        const response = await ioSaveOption(param, optionDelete);
        const { opcion: savedOption } = response.data;
        const filteredOptions = this.options.filter(
          (optionItem) => optionItem.opcionId !== savedOption.opcionId
        );
        this.options = filteredOptions;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    migrateOption(option) {
      this.$refs['option-migration-modal'].setOption(option);
      this.$refs['option-migration-modal'].show();
    }
  },
  props: {
    groupId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    groupTypeConfig: {
      type: String,
      required: false,
      default: 'list'
    },
    valueTypeConfig: {
      type: String,
      required: false,
      default: 'text'
    },
    extraTypeRender: {
      type: String,
      required: false,
      default: 'json'
    },
    childrenLevelsLimit: {
      type: Number,
      required: false,
      default: 2
    },
    isSuperAdmin: {
      type: Boolean,
      required: false,
      default: false
    },
    extras: {
      type: Object,
      required: false,
      default: {}
    }
  }
};
